export const MODULE_CHIPS = ['HR', 'Payroll', 'Benefits', 'Absence', 'Recruiting', 'Talent', 'All'];

export const ROTATING_PLACEHOLDERS = [
  'How do I configure absence management?',
  'What changed in Oracle HCM 26C?',
  'How do I set up Canadian payroll?',
  'Walk me through implementing recruiting',
  'How do I configure payroll elements?',
  'What are the steps to set up benefits?',
  'How do I manage time and labor?',
  'What is new in Oracle HCM 26B?',
];

export const getModulePlaceholder = (module) => {
  if (!module || module === 'All') return 'Ask anything about Oracle HCM…';
  return `Ask anything about ${module}…`;
};

export const stripMarkdownForCopy = (text) => {
  return String(text || '')
    .replace(/\*\*(.*?)\*\*/g, '$1')
    .replace(/\*(.*?)\*/g, '$1')
    .replace(/#{1,6}\s/g, '')
    .replace(/`(.*?)`/g, '$1')
    .replace(/\[(.*?)\]\(.*?\)/g, '$1')
    .trim();
};

const ANALYSIS_ALLOWED_TYPES = [
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const validateAnalysisFile = (file) => {
  if (!file) return { ok: false, error: 'No file selected.' };

  const maxSize = 10 * 1024 * 1024;
  if (file.size > maxSize) {
    return { ok: false, error: 'File must be under 10MB' };
  }

  const extOk = /\.(pdf|xlsx|xls|csv|docx)$/i.test(file.name);
  if (!ANALYSIS_ALLOWED_TYPES.includes(file.type) && !extOk) {
    return { ok: false, error: 'Only PDF, Excel, CSV, and Word files supported' };
  }

  return { ok: true };
};

export const getAnalysisPlaceholder = (hasFile, defaultPlaceholder) => {
  if (hasFile) return 'Ask something about this document...';
  return defaultPlaceholder;
};
